import { getCookieInClientSide } from "@/lib/utils/get-cookies-for-client";
import { FetchTerm } from "@/services/rest/common-service";
import { TermService } from "@/types/term-service";
import { useQuery } from "@tanstack/react-query";

export function useTermOfService() {
  return useQuery<TermService[]>({
    queryKey: ["terms", getCookieInClientSide("NEXT_LOCALE") || "en"],
    queryFn: () => FetchTerm(getCookieInClientSide("NEXT_LOCALE") || "en"),
  });
}
